import { observer } from "mobx-react-lite";
import { useContext, useEffect, useLayoutEffect, useRef, useState } from "react";
import MainKeeperAPI from "../API/MainKeeperAPI";
import MenuContext from "../components/ui/MenuContext";
import SwitcherStage from "../components/ui/SwitcherStage";
import Clicker from "../components/ui/Clicker";
import calculator_fields from "../settings/calculator.json";
import Dropbox from "../components/ui/Dropbox";
import { ReactComponent as Plus } from "../images/icons/plus.svg";
import { ReactComponent as Find } from "../images/icons/find.svg";
import { ReactComponent as Filter } from "../images/icons/filter.svg";
import TableRow from "../components/custom_tables/tableRow";
import "../styles/setup.css";
import MultiSwitcherStage from "../components/ui/MultiSwitcherStage";
import GroupsDifficultyAPI from "../API/GroupsDifficultyAPI";
import ParamsDifficultyAPI from "../API/ParamsDifficultyAPI";
import DifficultyLine from "../components/custom_tables/difficultyLine";

import { Context } from "..";
import useAssociationsEditor from "../hooks/useAssociationsEditor";
import useMainKeeper from "../hooks/useMainKeeper";
import useNotification from "../hooks/useNotification";

const MainKeeper = () => {

    const { success, warning, error } = useNotification();
    const { store } = useContext(Context);

    const [selectedItem, setSelectedItem] = useState(null);
    const [isTaskView, setIsTaskView] = useState(true);
    const [isPhysicalView, setIsPhysicalView] = useState(true);

    const scrollElement = useRef(null);
    const [hasScroll, setHasScroll] = useState(true);
    
    // main keeper
    const [objects, setObjects] = useState([]);
    const [newCell, setNewCell] = useState(null);
    const [selectionMode, setMode] = useState(false);
    const [selectionList, setList] = useState([]);
    // difficulties
    const [groupsDifficulty, setGroups] = useState([]);
    const [newGroupLine, setNewGroupLine] = useState(null);
    // groups
    const [activeGroup, setActiveGroup] = useState(0);

    const getGroupDifficultyByName = (name, arr) => {
        if (!arr) arr = groupsDifficulty;
        if (!arr) return [];
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].name == name) return arr[i];
        }
    }

    const [isOpenedDropbox, setIsOpenedDropbox] = useState(null);
    const [dropboxes, setDropboxes] = useState({
        viewOfOrganization: {
            values: calculator_fields.viewOfOrganization,
            defaultValue: 0,
            currentValue: 0,
            isOpened: false
        },
        taxationSystem: {
            values: calculator_fields.taxationSystem,
            defaultValue: 0,
            currentValue: 0,
            isOpened: false
        },
        mainKeeperMove: {
            values: calculator_fields.mainKeeperMove,
            defaultValue: 0,
            currentValue: 0,
            isOpened: false
        },
        megaPriceOfCountDocuments: {
            values: [],
            defaultValue: 0,
            currentValue: 0,
            isOpened: false
        },
        typeActivity: {
            values: [],
            defaultValue: 0,
            currentValue: 0,
            isOpened: false
        },
    });
    const changeOpenedDropbox = (dropboxName, state) => {
        let newDropboxes = { ...dropboxes };
        if (isOpenedDropbox != null) newDropboxes[isOpenedDropbox].isOpened = false;
        let newValue = { ...newDropboxes, [dropboxName]: { ...newDropboxes[dropboxName], isOpened: state } }
        setDropboxes(newValue);

        if (state) setIsOpenedDropbox(dropboxName);
        else setIsOpenedDropbox(null);
    }
    const changeValueDropbox = (dropboxName, value) => {
        let newDropboxes = { ...dropboxes };
        newDropboxes[isOpenedDropbox].isOpened = false;
        newDropboxes[dropboxName].currentValue = value;
        setDropboxes(newDropboxes);

        if (dropboxName != "association") return;
        changeAssociation(value != 0 ? newDropboxes.association.values[value].id : null);
    }

    const { mk_orgranization, mk_difficulty_docs, mk_difficulty_activity, mk_summ, mk_changeAssociation } = useMainKeeper(
        dropboxes.viewOfOrganization.values[dropboxes.viewOfOrganization.currentValue].value,
        dropboxes.taxationSystem.values[dropboxes.taxationSystem.currentValue].value,
        dropboxes.mainKeeperMove.values[dropboxes.mainKeeperMove.currentValue].value,
        dropboxes.megaPriceOfCountDocuments.currentValue,
        dropboxes.typeActivity.currentValue,
        (diff) => {
            let newDropboxes = {...dropboxes};
            newDropboxes.typeActivity.values = diff.filter(diff => diff.name == "Вид деятельности")[0].param_difficulties;
            newDropboxes.megaPriceOfCountDocuments.values = diff.filter(diff => diff.name == "Кол-во документов")[0].param_difficulties;
            setDropboxes(newDropboxes);
        }
    );

    const { associationsDropbox, changeAssociation } = useAssociationsEditor("mainkeeper_id");
    useEffect(() => {
        if (!associationsDropbox || associationsDropbox === null || !associationsDropbox.values || associationsDropbox.values.length === 0) return;
        mk_changeAssociation();
        setDropboxes({ ...dropboxes, association: associationsDropbox });
    }, [associationsDropbox]);

    useEffect(() => {
        if (!isTaskView && scrollElement.current.scrollHeight > scrollElement.current.clientHeight) setHasScroll(true);
        loadData(isPhysicalView).then(() => console.log("Список задач загружен"));
        // loadWorkers().then(() => console.log("Список сотруников загружен"));
        loadGroupsDifficulty(dropboxes).then(() => console.log("Список коэфицентов усложнения загружен"));
    }, [isTaskView]);

    const loadData = async (isPhysical) => {
        try {
            const tasks = await MainKeeperAPI.getAll(isPhysical);
            setObjects(tasks.data);

            return tasks.data;
        } catch (err) {
            console.log("[x] Ошибка загрузки задач ГБ:", err);
        }
    }
    const loadGroupsDifficulty = async (newDropboxes) => {
        try {
            const groups = await GroupsDifficultyAPI.getAll();
            if (groups.status !== 200) throw groups;
            setGroups(groups.data);

            let dropValues;
            if (!newDropboxes) dropValues = {...dropboxes};
            else dropValues = {...newDropboxes};
            dropValues.typeActivity.values = getGroupDifficultyByName("Вид деятельности", groups.data).param_difficulties;
            dropValues.megaPriceOfCountDocuments.values = getGroupDifficultyByName("Кол-во документов", groups.data).param_difficulties;

            setDropboxes(dropValues);
            return groups.data;
        } catch (err) {
            console.log("[group_difficulty] [getAll] error:", err);
        }
    }

    // Редактирование задачи ГБ
    const setValue = (index, newValue, field) => {
        let newArr = objects;
        newArr[index][field] = newValue;
        setObjects([...newArr]);
    }
    const removeValue = async (index) => {
        try {
            let newObjects = objects;
            if (!newObjects[index].id) newObjects = await loadData(isPhysicalView);
            const response = await MainKeeperAPI.remove(newObjects[index].id);
            if (response.status !== 200) throw response;

            newObjects = newObjects.filter((item, itemIndex) => itemIndex !== index);
            setObjects([...newObjects]);
        } catch (err) {
            console.log("[x] Ошибка удаления задачи в ГБ:", err);
            error("Ошибка удаления задачи ГБ");
        }
    }
    const saveValue = async (value) => {
        try {
            const response = await MainKeeperAPI.update(value);
            if (response.status !== 200) throw response;
        } catch (err) {
            console.log("[x] Ошибка обновления строки в ГБ:", err);
            error("Ошибка сохранения задачи ГБ");
        }
    }
    // Создание новой задачи ГБ
    const addingValue = () => {
        setNewCell({ 
            name: "", 
            interval: 1, 
            physical: isPhysicalView, 
            usn_d: 0, 
            usn_dr: 0, 
            vat_twenty: 0, 
            vat_five: 0, 
            osno: 0 
        });
    }
    const setValueNewCell = (value, field) => {
        let newValue = newCell;
        newValue[field] = value;
        setNewCell({ ...newValue });
    }
    const saveNewCell = async (value) => {
        try {
            const response = await MainKeeperAPI.create(value);
            if (response.status !== 200) throw response;

            let newObjects = await loadData(isPhysicalView);
            setObjects(newObjects);
            setNewCell(null);
        } catch (err) {
            console.log("Ошибка создания строки в ГБ:", err);
            error("Ошибка создания задачи ГБ");
        }
    }

    // Редактирование коэффицентов усложенния
    const setGroupLineValue = (groupIndex, index, value, field) => {
        let newGroups = groupsDifficulty;
        newGroups[groupIndex].param_difficulties[index][field] = value;
        setGroups([...newGroups]);
    }
    const removeGroupLine = async (groupIndex, index) => {
        try {
            let newGroups = groupsDifficulty;
            if (!newGroups[groupIndex].param_difficulties[index].id) newGroups = await loadGroupsDifficulty();
            const response = await ParamsDifficultyAPI.remove(newGroups[groupIndex].param_difficulties[index].id);
            if (response.status !== 200) throw response;

            newGroups[groupIndex].param_difficulties = newGroups[groupIndex].param_difficulties.filter((item, itemIndex) => itemIndex !== index);
            setGroups([...newGroups]);
        } catch (err) {
            console.log("[x] Ошибка удаления коэффицента усложнения:", err);
            error("Ошибка удаления коэффицента усложенния");
        }
    }
    const saveGroupLine = async (value) => {
        try {
            const response = await ParamsDifficultyAPI.update(value);
            if (response.status !== 200) throw response;
        } catch (err) {
            console.log("[x] Ошибка изменения коэффицента усложнения:", err);
            error("Ошибка сохранения коэффицента усложнения");
        }
    }
    // Создание нового коэффицента усложения
    const addingGroupValue = () => {
        setNewGroupLine({ name: "", value: 1, group_id: groupsDifficulty[activeGroup].id });
    }
    const setNewGroupLineValue = (value, field) => {
        let newGroup = newGroupLine;
        newGroup[field] = value;
        setNewGroupLine({ ...newGroup });
    }
    const saveNewGroupLine = async () => {
        try {
            const response = await ParamsDifficultyAPI.create(newGroupLine);
            if (response.status !== 200) throw response;

            let newGroups = await loadGroupsDifficulty();
            setGroups(newGroups);
            setNewGroupLine(null);
        } catch (err) {
            console.log("[x] Ошибка добавления коэффицента усложнения:", err);
            error("Ошибка добавления коэффицента усложнения");
        }
    }

    const formatNumber = (num) => {
        if (!num) return 0;
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }
    const changeSelection = (index) => {
        let newSelections = selectionList;
        if (newSelections.includes(index)) newSelections = newSelections.filter(item => item !== index);
        else newSelections.push(index);
        setList([...newSelections]);
    }

    const cloneObjects = async (cloneAll) => {
        try {
            if (!cloneAll && selectionList.length === 0) {
                warning("Отсутствуют задачи для копирования");
                return;
            }
            const response = await MainKeeperAPI.clone(cloneAll ? true : false, selectionList, isPhysicalView);
            if (response.status !== 200) throw response;

            success(`Задачи (${response.data}) успешно скопированы в раздел ${isPhysicalView?"ЮЛ":"ИП"}`);
        } catch (err) {
            console.log(`[x] Ошибка копирования данных в ${isPhysicalView?"ЮЛ":"ИП"}:`, err);
            error(`Ошибка копирования данных в ${isPhysicalView?"ЮЛ":"ИП"}`);
        }
    }
    

    return (
        <div className="setupBlock">
            <div className="managementMenu">
                <button className="activeButton" onClick={() => window.location.replace("/calc")}>Назад</button>
                <MultiSwitcherStage
                    values={[{ name: "Коэффицент усложнения" }, { name: "Детализация" }]}
                    defaultValue={0}
                    selectValue={(newValue) => setIsTaskView(newValue === 0)}
                />
            </div>
            {isTaskView 
                ? <div className="setupContent">
                    <div className="paramsBlock">
                        <div className="title">Задачи ГБ</div>
                        { dropboxes.association && <div className={`paramsList${dropboxes.association.currentValue === 0 ? " error" : ""}`} style={{ flex: 0 }}>
                            <ul>
                                <li>
                                    <div className="params" style={{ width: 430 }}>
                                        <div className="title">Ответственный</div>
                                        <div className="attribute">
                                            <Dropbox 
                                                textValue={dropboxes.association.values[dropboxes.association.currentValue]?.name}
                                                isRight={true}
                                                isOpen={dropboxes.association.isOpened}
                                                changeOpened={(value) => changeOpenedDropbox("association", value)}
                                                isError={dropboxes.association.currentValue === 0}
                                            >
                                                {dropboxes.association.values.map((item, index) => <li 
                                                    className={dropboxes.association.currentValue === index || (dropboxes.association.currentValue === null && index == 0) ? "selected" : ""}
                                                    key={item+index}
                                                    onClick={() => changeValueDropbox("association", index)}
                                                >
                                                    <div className="number">{index+1}.</div>
                                                    <div className="value">{item.name}</div>
                                                </li>)}
                                            </Dropbox>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div> }
                        <div className="paramsList">
                            <ul>
                                <li>
                                    <div className="params" style={{ width: 430 }}>
                                        <div className="title">
                                            <Dropbox 
                                            textValue={dropboxes.viewOfOrganization.values[dropboxes.viewOfOrganization.currentValue].name}
                                            isRight={false}
                                            isOpen={dropboxes.viewOfOrganization.isOpened}
                                            changeOpened={(value) => changeOpenedDropbox("viewOfOrganization", value)}
                                        >
                                            {dropboxes.viewOfOrganization.values.map((item, index) => <li 
                                                className={dropboxes.viewOfOrganization.currentValue === index ? "selected" : ""}
                                                key={item+index}
                                                onClick={() => changeValueDropbox("viewOfOrganization", index)}
                                            >
                                                <div className="number">{index+1}.</div>
                                                <div className="value">{item.name}</div>
                                            </li>)}
                                        </Dropbox> на <Dropbox
                                            textValue={dropboxes.taxationSystem.values[dropboxes.taxationSystem.currentValue].name}
                                            isRight={true}
                                            isOpen={dropboxes.taxationSystem.isOpened}
                                            changeOpened={(value) => changeOpenedDropbox("taxationSystem", value)}
                                        >
                                            {dropboxes.taxationSystem.values.map((item, index) => <li 
                                                className={dropboxes.taxationSystem.currentValue === index ? "selected" : ""}
                                                key={item+index}
                                                onClick={() => changeValueDropbox("taxationSystem", index)}
                                            >
                                                <div className="number">{index+1}.</div>
                                                <div className="value">{item.name}</div>
                                            </li>)}
                                        </Dropbox></div>
                                        {/* <div className="attribute"><Dropbox
                                            textValue={dropboxes.mainKeeperMove.values[dropboxes.mainKeeperMove.currentValue].name}
                                            isRight={false}
                                            isOpen={dropboxes.mainKeeperMove.isOpened}
                                            changeOpened={(value) => changeOpenedDropbox("mainKeeperMove", value)}
                                        >
                                            {dropboxes.mainKeeperMove.values.map((item, index) => <li 
                                                className={dropboxes.mainKeeperMove.currentValue === index ? "selected" : ""}
                                                key={item+index}
                                                onClick={() => changeValueDropbox("mainKeeperMove", index)}
                                            >
                                                <div className="number">{index+1}.</div>
                                                <div className="value">{item.name}</div>
                                            </li>)}
                                        </Dropbox></div> */}
                                    </div>
                                    {/* <div className="summ">{formatNumber(Math.ceil(prices[0]))} ₽</div> */}
                                    <div className="summ">{formatNumber(mk_orgranization)} ₽</div>
                                </li>
                                <li>
                                    <div className="params">
                                        <div className="title">Надбавка за кол-во документов</div>
                                        <div className="attribute">{ dropboxes.megaPriceOfCountDocuments.values && <Dropbox
                                            textValue={dropboxes.megaPriceOfCountDocuments.values[dropboxes.megaPriceOfCountDocuments.currentValue]?.name}
                                            isRight={true}
                                            isOpen={dropboxes.megaPriceOfCountDocuments.isOpened}
                                            changeOpened={(value) => changeOpenedDropbox("megaPriceOfCountDocuments", value)}
                                        >
                                            {dropboxes.megaPriceOfCountDocuments.values.map((item, index) => <li 
                                                className={dropboxes.megaPriceOfCountDocuments.currentValue === index ? "selected" : ""}
                                                key={item+index}
                                                onClick={() => changeValueDropbox("megaPriceOfCountDocuments", index)}
                                            >
                                                <div className="number">{index+1}.</div>
                                                <div className="value">{item.name}</div>
                                            </li>)}
                                        </Dropbox>}</div>
                                    </div>
                                    <div className="summ">{formatNumber(mk_difficulty_docs)} ₽</div>
                                </li>
                                <li>
                                    <div className="params">
                                        <div className="title">Надбавка за вид деятельности</div>
                                        <div className="attribute">{ dropboxes.typeActivity.values && <Dropbox
                                            textValue={dropboxes.typeActivity.values[dropboxes.typeActivity.currentValue]?.name}
                                            isRight={true}
                                            isOpen={dropboxes.typeActivity.isOpened}
                                            changeOpened={(value) => changeOpenedDropbox("typeActivity", value)}
                                        >
                                            {dropboxes.typeActivity.values.map((item, index) => <li 
                                                className={dropboxes.typeActivity.currentValue === index ? "selected" : ""}
                                                key={item+index}
                                                onClick={() => changeValueDropbox("typeActivity", index)}
                                            >
                                                <div className="number">{index+1}.</div>
                                                <div className="value">{item.name}</div>
                                            </li>)}
                                        </Dropbox>}</div>
                                    </div>
                                    <div className="summ">{formatNumber(mk_difficulty_activity)} ₽</div>
                                </li>
                            </ul>
                            <div className="summ">
                                <div className="text">Итого:</div>
                                {/* <div className="value">{formatNumber(Math.ceil(prices[0] + prices[1] + prices[2]))} ₽</div> */}
                                <div className="value">{formatNumber(mk_summ)} ₽</div>
                            </div>
                        </div>
                    </div>
                    <div className="contentSetupBlock">
                        <div>
                            <div className="title">Коэфиценты усложенния</div>
                            {groupsDifficulty.length > 0 && <MultiSwitcherStage 
                                values={groupsDifficulty}
                                selectValue={(index) => setActiveGroup(index)}
                                backIsWhite={true}
                            />}
                            <div className="block_table">
                                <div className="header">
                                    <div className="title">{groupsDifficulty.length > 0 && groupsDifficulty[activeGroup].name}</div>
                                    { store.userInfo && store.userInfo.isLicensed == true && <button className="activeButton" onClick={addingGroupValue}>Добавить <Plus/></button> }
                                </div>
                                <ul>
                                    {groupsDifficulty.map((groupItem, groupIndex) => (
                                        groupItem && groupItem.param_difficulties && groupItem.param_difficulties.length > 0 && groupItem.param_difficulties.map((item, index) =>
                                            groupIndex == activeGroup && <DifficultyLine 
                                                key={item+index}
                                                value={item}
                                                setValue={(newValue, field) => setGroupLineValue(groupIndex, index, newValue, field)}
                                                onDelete={() => removeGroupLine(groupIndex, index)}
                                                saveValue={(newValue) => saveGroupLine(newValue)}
                                            />
                                        )
                                    ))}
                                    {newGroupLine && <DifficultyLine 
                                        value={newGroupLine}
                                        isNew={true}
                                        setValue={(newValue, field) => setNewGroupLineValue(newValue, field)}
                                        saveValue={(newValue) => saveNewGroupLine(newValue)}
                                        onDelete={() => setNewGroupLine(null)}
                                    /> }
                                </ul>
                            </div>
                        </div>
                    </div>
                </div> 
                : <div className="setupBigContent">
                    <div className="title">Детализация</div>
                    <div className="tableContainer">
                        <div className="tableSettings">
                            <div className="left_side">
                                <MultiSwitcherStage
                                    backIsWhite={true}
                                    defaultValue={0}
                                    values={[{ name: "ИП" }, { name: "ЮЛ" }]}
                                    selectValue={(newValue) => {
                                        setIsPhysicalView(newValue === 0);
                                        loadData(newValue === 0).then(() => console.log("[UPD] Список задач обновлен"));
                                        setList([]);
                                        setMode(false);
                                    }}
                                />
                                <div className="text">Всего найдено записей: {objects.length}</div>
                            </div>
                            <div className="right_side">
                                <button className="defaultButton disabled"><Filter/></button>
                                <button className="defaultButton disabled"><Find/></button>
                                { store.userInfo && store.userInfo.isLicensed == true && <button 
                                    className={`activeButton${selectionMode ? " disabled" : ""}`} 
                                    onClick={() => selectionMode === false && addingValue()}
                                >Добавить <Plus/></button> }
                            </div>
                        </div>
                        { store.userInfo && store.userInfo.isLicensed == true && selectionMode === false && <div className="button">
                            <button className="activeButton" onClick={() => selectionMode === false && setMode(true)}>Дублировать в {isPhysicalView ? "ЮЛ" : "ИП"}</button>
                        </div> }
                        { store.userInfo && store.userInfo.isLicensed == true && selectionMode === true && <div className="button">
                            <button className="activeButton" onClick={() => cloneObjects()}>Дублировать выделенное</button>
                            <button className="activeButton" onClick={() => cloneObjects(true)}>Дублировать всё</button>
                            <button className="redButton" onClick={() => {
                                if (selectionMode !== true) return;
                                setMode(false);
                                setList([]);
                            }}>Отменить выделение</button>
                        </div>}
                        <div className="tableContent">
                            <div className={scrollElement ? "tableScroller scrolled" : "tableScroller"} ref={scrollElement}>
                                <div className="tableHeader">
                                    <div className="num">№п/п</div>
                                    <div className="name">Регулярные операции</div>
                                    <div className="attrs">
                                        <div className="tdContainer">
                                            <div className="title">Переодичность</div>
                                            <div className="subTitle">(раз в год)</div>
                                        </div>
                                        <div className="tdContainer">
                                            <div className="title">УСН Д</div>
                                        </div>
                                        <div className="tdContainer">
                                            <div className="title">УСН Д-Р</div>
                                        </div>
                                        <div className="tdContainer">
                                            <div className="title">НДС 20% на УСН</div>
                                        </div>
                                        <div className="tdContainer">
                                            <div className="title">НДС 5%, 7% на УСН</div>
                                        </div>
                                        <div className="tdContainer">
                                            <div className="title">ОСНО</div>
                                        </div>
                                    </div>
                                </div>
                                <ul className="TABLE">
                                    {objects.map((item, index) => <TableRow 
                                        value={item} 
                                        setValue={(newValue, field) => setValue(index, newValue, field)}
                                        saveValue={(value) => saveValue(value)}
                                        onDelete={() => removeValue(index)}
                                        index={objects.length - index - 1}
                                        key={item+index}

                                        selectionMode={selectionMode}
                                        selectionList={selectionList}
                                        changeSelection={(id) => changeSelection(id)}
                                    />)}
                                    {newCell && !selectionMode && <TableRow 
                                        value={newCell} 
                                        setValue={(newValue, field) => setValueNewCell(newValue, field)}
                                        saveValue={(value) => saveNewCell(value)}
                                        onDelete={() => setNewCell(null)}
                                        index={-1}
                                        isNew={true}
                                    /> }
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default observer(MainKeeper);
